import { Component } from '@angular/core';

declare var jQuery: any;

@Component({
  selector: 'psm-blank-layout',
  templateUrl: 'blankLayout.template.html'
})
export class BlankLayoutComponent {

  public ngAfterViewInit() {
    jQuery('body').addClass('gray-bg');
  }

  public ngOnDestroy() {
    jQuery('body').removeClass('gray-bg');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/common/layouts/blankLayout.component.ts